<template lang="pug">
  div
    el-dialog(
      :title='modalTitle'
      :visible.sync='showModal'
       width='60%'
       v-loading='loading'
    )
      div
        el-collapse(
          v-for='(conversa, index) in historico.content'
          :key='index'
          v-model='panelAtiva[index]'
          accordion
          style='padding: 10px 0px 20px 0px;'
        )
          div.assunto {{ conversa.assunto }}
          el-collapse-item(v-for="(mensagem, index) in conversa.mensagens" :key="index")
            template(slot='title')
              .title-content
                div
                  span {{ mensagem.remetente.nomeRazaoSocial }}
                div
                  el-tooltip(content='Data enviada' placement="top" effect="dark")
                    span {{ mensagem.dataEnviada | timestamp }}
            span(v-html='mensagem.conteudo')
            div(v-if="mensagem.anexos.length > 0")
              div(v-for="(anexo, index) in mensagem.anexos" :key="index")
                el-divider(v-if="index > 0")
                div.anexos
                  span.anexo-name {{ anexo.nome }}
                  div(class="fa fa-download icone-download" style="color: #666666;" @click="downloadAnexo(anexo)")
            div.sem-anexo(v-else) Não há anexos disponíveis.
            .data-limite-container
              span(v-if='mensagem.dataLimiteResposta') Data Limite para resposta: {{mensagem.dataLimiteResposta | timestamp}}
        span(v-if='historico.content ? historico.content.length === 0 : null') Não existem mensagens registradas para essa solicitação.

</template>
<script>
import { VueEditor } from 'vue2-editor';
import { listConversasBySolicitacao } from '@/services/conversaService';
import { findByCaminho } from '@/services/documentoService';
import { TIPO_CONVERSA } from '@/constants/constants.js';
import ModalModelos from '@/components/modalListarModelos.vue';

export default {
  components: {
    VueEditor,
    ModalModelos,
  },
  props: {
    solicitacao: {
      type: Object,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
    idSolicitacao: {
      type: Number,
      required: false
    },
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  data() {
    return {
      modalTitle: '',
      historico: [],
      panelAtiva: [],
      conversa: null,
      loading: false,
    }
  },
  async mounted() {
    this.loading = true;
    this.historico = await listConversasBySolicitacao(this.solicitacao.id, TIPO_CONVERSA.TODOS, 0, 999999);

    if (this.historico && this.historico.content.length > 0) {
      this.conversa = this.historico.content[this.historico.content.length - 1];
    }

    this.modalTitle = 'Histórico de Conversas';
    this.loading = false;
  },

  methods: {
    fecharModal() {
      this.$emit('close-modal');
    },
    async downloadAnexo(anexo) {
      const fileLink = document.createElement('a');

      const arquivo = await findByCaminho(anexo.caminho);

      if (arquivo) {
        const fileURL = new Blob([arquivo]);
        fileLink.href = window.URL.createObjectURL(fileURL);

        fileLink.setAttribute('download', anexo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      }

      return Promise.resolve();
    },
  }
}
</script>
<style lang="scss" scoped>

.title-content {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.anexos {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  height: 24px;
  color: #666666;
}

.sem-anexo {
  padding-bottom: 30px;
}

.data-limite-container {
  justify-content: center;
  color: #666666;
  font-weight: bold;
  align-items: center;
  display: flex;
  font-size: 15px;
  padding-top: 12px;
}

.padding-bottom {
  padding-bottom: 15px;
}

.anexo-name {
  margin-left: 12px;
}

.assunto {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 25px;
  margin-left: 20px;
}

.position {
  width: 100%;
  font-size: 15px;
}

</style>
